import { isString } from "@omnia/shared/utils/utils";
import { IOmniaSession, IOmniaSettings, isNumber } from "../omnia"
import { INutrient, INutrientGroup, NutrientType } from "../types"
import { getNutrientGroups, LimeEnabledFromYear } from "../utils"

export class NutrientFilter {


    public nutrientGroups: INutrientGroup[];
    private _nutrientGroup: INutrientGroup;
    private _nutrient: INutrient;

    private _allNutrients: INutrient[];

    constructor(private session: IOmniaSession, private settings: IOmniaSettings, private onNutrientChanged: ((nutrient: INutrient) => any) = (n => null)) {
        this.setup();
    }

    private setup() {

        let groups = getNutrientGroups(this.session.yearId >= LimeEnabledFromYear);

        this.nutrientGroups = groups.groups;
        this._allNutrients = groups.nutrients;

        if (!this.restoreSettings()) {
            this.nutrientGroup = this.nutrientGroups[0];
        }

    }

    public restoreSettings(): boolean {

        let groupKey: string = this.settings.get("nutrients.group");
        let ntrKey: string = this.settings.get("nutrients.nutrient");

        if (groupKey) {

            let group = this.nutrientGroups.find(g => g.key == groupKey);

            if (group) {

                this.nutrientGroup = group;

                let ntr = this.nutrients.find(n => n.key == ntrKey);
                if (ntr) this.nutrient = ntr;

                return true;
            }

        }

    }

    get nutrients() {
        if (this._nutrientGroup) {
            return this._nutrientGroup.nutrients;
        }
    }

    get nutrientGroup() {
        return this._nutrientGroup;
    }

    get nutrientGroupKey(): string {
        return this._nutrientGroup ? this._nutrientGroup.key : null;
    }

    set nutrientGroup(value: INutrientGroup) {

        this._nutrientGroup = value;
        this.settings.set("nutrients.group", value ? value.key : undefined);

        if (!value) {
            this.nutrient = null;
        }
        else {
            let nutrients = value.nutrients;
            if ((!this._nutrient) || (nutrients.every(n => n != this._nutrient))) {
                this.nutrient = nutrients[0];
            }
        }

    }

    get nutrient() {
        return this._nutrient;
    }

    get nutrientKey(): string {
        return this._nutrient ? this._nutrient.key : null;
    }

    set nutrient(value: INutrient) {
        this.setNutrient(value, true);
    }

    public setNutrient(value: NutrientType | string | INutrient, notify: boolean = true) {

        let nutrient = findNutrient(this.nutrients, value)

        if ((!nutrient) && value) {
            const group = this.nutrientGroups.find(g => g.key === "*")
            this.nutrientGroup = group
            nutrient = findNutrient(this.nutrients, value)
        }

        if (nutrient) {

            this._nutrient = nutrient;

            this.settings.set("nutrients.nutrient", nutrient ? nutrient.key : undefined);

            if (notify) {
                this.onNutrientChanged(nutrient);
            }

        }
    }

    getSubset(nutrientKeys: string[]) {
        return this._allNutrients.filter(n => nutrientKeys.some(k => k == n.key));
    }

    getNutrient(nutrient: string | NutrientType) {
        return this._allNutrients.find(n => (n.key == nutrient) || (n.nutrient == nutrient));
    }

}


function findNutrient(list: INutrient[], value: NutrientType | string | INutrient) {

    let nutrient: INutrient;

    if (isString(value)) {
        nutrient = list.find(n => n.key == value)
    }
    else if (isNumber(value)) {
        nutrient = list.find(n => n.nutrient == value)
    } else {
        nutrient = list.find(n => n === value)
    }

    return nutrient

}
